import {APIEvents} from "../../../constants/AnalyticsEventKeys";
import {MobileAnalyticsHelper} from "@amzn/dolphin-web-framework";
import {getNPSWClient} from "../../base/ClientInterface";

export function GetPackageAttributeAPI(data, dispatcher, nextAction, errorAction) {
    let startTime = Date.now();
    getNPSWClient().getPackageAttribute(data)
        .then(({success, data}) => {
            if (success) {
                dispatcher({
                    type: nextAction,
                    data: data
                });
                MobileAnalyticsHelper.executeAPIAnalytics(APIEvents.GetPackageAttributes, startTime);
            } else {
                dispatcher({
                    type: errorAction
                });
                MobileAnalyticsHelper.executeAPIAnalytics(APIEvents.GetPackageAttributes, startTime, true);
            }
        });
}